import './index.scss';
import React from 'react';
import defaultAvatar from '../../common/businessCommon/user/userAvatar/images/defaultAvatar.png';
import rightIcon from '../../images/arrow-right.png';
import LangCache from '../../base/langCache';
import { $window } from '../../common/utils/bom';
export const GotoPlatformNavItem = React.memo(() => {
    const LANG = LangCache.getLang();
    const onClick = () => {
        $window.location.href = '/index';
    };

    return (
        <div className="goto-platform-nav-item">
            <div className="goto-platform-nav-item-content" onClick={onClick}>
                <img className="goto-platform-nav-item-icon" src={defaultAvatar} />
                <span className="goto-platform-nav-item-text">{LANG['去学习平台']}</span>
                <img className={`goto-platform-nav-item-arrow`} src={rightIcon} />
            </div>
        </div>
    );
});
